// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2nsVd","info":"UpdateTermsInfo_info__1bOm1"};